<template>
  <div class="mode-switch">
    <button
      :class="{ active: currentMode === 'pvp' }"
      @click="handleModeChange('pvp')"
    >
      {{ t('mode.pvp') }}
    </button>
    <button
      :class="{ active: currentMode === 'pvc' }"
      @click="handleModeChange('pvc')"
    >
      {{ t('mode.pvc') }}
    </button>
  </div>
</template>

<script setup>
import { t } from '@/i18n/index.js'

const props = defineProps({
  currentMode: {
    type: String,
    default: 'pvp'
  }
})

const emit = defineEmits(['mode-change'])

function handleModeChange(mode) {
  if (props.currentMode !== mode) {
    emit('mode-change', mode)
  }
}
</script>

<style scoped>
.mode-switch {
  display: flex;
  background: #1f2937;
  border-radius: 10px;
  padding: 4px;
  gap: 4px;
}

.mode-switch button {
  padding: 8px 20px;
  border: none;
  border-radius: 7px;
  background: transparent;
  color: #94a3b8;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s;
}

.mode-switch button.active {
  background: #22c55e;
  color: #fff;
  font-weight: 600;
}

.mode-switch button:hover:not(.active) {
  color: #f1f5f9;
}

@media (max-width: 720px) {
  .mode-switch {
    padding: 3px;
    gap: 3px;
  }

  .mode-switch button {
    padding: 6px 12px;
    font-size: 0.8rem;
    white-space: nowrap;
  }
}
</style>